import { render, staticRenderFns } from "./BtnAdicionarPedidoCarga.vue?vue&type=template&id=67626451&"
import script from "./BtnAdicionarPedidoCarga.vue?vue&type=script&lang=js&"
export * from "./BtnAdicionarPedidoCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports